{
  "title": "MPPNext Web Site",
  "account": "帳號",
  "secret": "密碼",
  "login": "登入",
  "loginError": "輸入錯誤",
  "badCaptcha": "驗證碼輸入錯誤",
  "lockoutPrompt": "您的帳號由於超過了嘗試登入{maxLoginAttempts}次數已被暫時鎖定, 請稍後{lockoutDuration}分鐘再試",
  "version": "版本: v{v}"
}